import React, { useState } from 'react';
import styled, { css } from 'styled-components';

const Container = styled.div`
    flex: 1;
    display: flex;
    width: 100%;
`;

const disabledStyle = css`
    background-color: #fbd1d9 !important;
    pointer-events: none !important;
`;

const phaseStyle = css`
    padding: 0 !important;
    border: none !important;
    border-left: 2px solid #58585A !important;
`;

const defaultStyle = css`
    padding: 0.5rem !important;
    border: 2px solid #58585A !important;
    border-radius: 30px !important;
`;

const StyledInput = styled.input<{ isDisabled?: boolean; phase?: boolean }>`
    flex: 1 !important;
    width: 100% !important;
    font-size: 0.9rem !important;
    outline: none !important;
    appearance: none !important;
    cursor: pointer !important;
    text-align: center !important;
    ${({ isDisabled }) => isDisabled && disabledStyle}
    ${({ phase }) => phase ? phaseStyle : defaultStyle}
`;

const formatValue = (value: number, type: 'currency' | 'percentage'): string => {
    return type === 'currency'
        ? `${value.toFixed(2)} zł`
        : `${(value * 100).toFixed(2)} %`;
}

interface CustomInputProps {
    value: number;
    onChange: (value: number) => void;
    type: 'currency' | 'percentage';
    phase?: boolean;
    disabled?: boolean;
}

const CustomInput: React.FC<CustomInputProps> = ({ value, onChange, type, phase, disabled }) => {
    const [displayValue, setDisplayValue] = useState<string>(formatValue(value, type));

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value;
        setDisplayValue(rawValue);

        const numericValue = rawValue.replace(',', '.');
        if (!isNaN(Number(numericValue))) {
            const newValue = type === 'percentage' ? Number(numericValue) / 100 : Number(numericValue);
            onChange(newValue);
        }
    };

    const handleBlur = () => {
        setDisplayValue(formatValue(value, type));
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        e.target.select();
        setDisplayValue(type === 'percentage' ? (value * 100).toString() : value.toString());
    };

    return (
        <Container>
            <StyledInput
                type="text"
                value={displayValue}
                onChange={handleInputChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onClick={(e: React.MouseEvent<HTMLInputElement>) => e.currentTarget.select()}
                isDisabled={disabled}
                phase={phase}
            />
        </Container>
    );
};

export default CustomInput;
